import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PERSISTENCY_MODULE_CONFIG } from '../persistency-module-config';
import { PremessaStatus } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class PremessaApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(PERSISTENCY_MODULE_CONFIG);

  private readonly premessaUrl = `${this.config.apiBaseUrl}/api/app/TenderFormAnswerPremessa`;

  downloadTemplate(tenderFormAnswerId: string): Observable<Blob> {
    return this.http.get(`${this.premessaUrl}/${tenderFormAnswerId}/template`, {
      responseType: 'blob',
    });
  }

  uploadPremessa(
    tenderFormAnswerId: string,
    file: File,
  ): Observable<PremessaStatus> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<PremessaStatus>(
      `${this.premessaUrl}/${tenderFormAnswerId}`,
      formData,
    );
  }

  getPremessa(tenderFormAnswerId: string): Observable<PremessaStatus> {
    return this.http.get<PremessaStatus>(
      `${this.premessaUrl}/${tenderFormAnswerId}`,
    );
  }

  deletePremessa(tenderFormAnswerId: string): Observable<void> {
    return this.http.delete<void>(`${this.premessaUrl}/${tenderFormAnswerId}`);
  }
}
